import { useEffect, useState } from "react";

const SHEET_PX = 794; // 210mm A4 width at 96dpi
const calc = () => Math.min(1, (window.innerWidth - 24) / SHEET_PX);

/** Scales the A4 print preview down to fit narrow screens (phones/tablets). Returns an inline style or undefined. */
export const useSheetZoom = () => {
  const [zoom, setZoom] = useState(calc);
  useEffect(() => {
    const onResize = () => setZoom(calc());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return zoom < 1 ? { zoom } : undefined;
};
